module.exports = "#button-container,#alert-container,#adminName{display:flex;justify-content:center;align-items:center}\n"